import { AnalyticsScreenProvider, Flex, Link, Text, OnboardingLayout } from "@wayflyer/flyui";
import { IconArrowRight24Line } from "@wayflyer/flyui-icons/24/line";
import type { ReactNode } from "react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { OnboardingStepperNext } from "onboarding";
import { useInviteModalActions } from "shared-ui";
import { handleContactTeam } from "shared-utils";

import { MESSAGES } from "../../components/bank-controller-next/message-definitions";
import { BankControllerNext, RequireBankConnectionModal } from "../../components";
import { PAGE_TYPE, useFundingApplicationNavigation } from "../../hooks/navigation-next";

import { BankControllerProvider, useBankControllerContext } from "./hooks/bank-controller-context";

const BankingNextContent = () => {
  const intl = useIntl();

  const { stepCompleted, uploadsInProgress, ready, isSubmitting, handleNext } = useBankControllerContext();
  const { openInviteModal } = useInviteModalActions();
  const [isRequireConnectionModalOpen, setIsRequireConnectionModalOpen] = useState(false);

  const { nextButtonLabel } = useFundingApplicationNavigation({ currentPage: PAGE_TYPE.BANKING });

  const onNext = () => {
    if (!stepCompleted) {
      setIsRequireConnectionModalOpen(true);
      return;
    }
    handleNext();
  };

  return (
    <>
      <RequireBankConnectionModal
        isOpen={isRequireConnectionModalOpen}
        onClose={() => setIsRequireConnectionModalOpen(false)}
      />
      <OnboardingLayout
        variant="wide"
        titleSlot={<OnboardingStepperNext currentStep={4} />}
        title={intl.formatMessage(MESSAGES.pageTitle)}
        subtitle={intl.formatMessage(MESSAGES.pageSubtitle)}
        footer={
          <Flex direction="column" gap="2">
            <Text fontWeight="semiBold" size="xs">
              {intl.formatMessage(MESSAGES.needHelpHeading)}
            </Text>
            <Text size="xs">
              <FormattedMessage
                {...MESSAGES.footerSupportText}
                values={{
                  a1: (chunks: ReactNode) => <Link onClick={() => openInviteModal()}>{chunks}</Link>,
                  a2: (chunks: ReactNode) => <Link onClick={handleContactTeam}>{chunks}</Link>,
                }}
              />
            </Text>
          </Flex>
        }
        actions={{
          primary: {
            content: nextButtonLabel,
            onAction: onNext,
            disabled: uploadsInProgress || !ready,
            loading: isSubmitting,
            icon: IconArrowRight24Line,
            analyticsId: "bank-controller-next-button",
          },
          // TODO: Add back button
          // secondary: {
          //   content: isMobile ? undefined : intl.formatMessage(COMMON_MESSAGES.backLabel),
          //   icon: isMobile ? IconArrowLeft24Line : undefined,
          //   onAction: handleBack,
          //   analyticsId: "bank-controller-back-button",
          // },
        }}
      >
        <BankControllerNext />
      </OnboardingLayout>
    </>
  );
};

export const BankingNextPage = () => (
  <AnalyticsScreenProvider screen="onboarding-banking">
    <BankControllerProvider>
      <BankingNextContent />
    </BankControllerProvider>
  </AnalyticsScreenProvider>
);
